import { render, staticRenderFns } from "./webSupport.vue?vue&type=template&id=ef05bf6e&scoped=true&"
import script from "./webSupport.vue?vue&type=script&lang=js&"
export * from "./webSupport.vue?vue&type=script&lang=js&"
import style0 from "./webSupport.vue?vue&type=style&index=0&id=ef05bf6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef05bf6e",
  null
  
)

export default component.exports